export default "__VITE_ASSET__B4uGYdx0__"